import type { ProviderConfig } from "../schema/provider.js";
import type { TelemetryProvider, TelemetryRuntime } from "../core/types.js";
import type { ConsoleProviderConfig } from "../schema/provider-core.js";
import { createConsoleProvider } from "./console/index.js";
import type { ProviderCreateContext } from "./plugin-context.js";
import { createProviderFromPlugin, registerProviderPlugin } from "./plugins/registry.js";

registerProviderPlugin("console", (config, _runtime) =>
  createConsoleProvider(config as ConsoleProviderConfig),
);

export function createProviderFromConfig(
  config: ProviderConfig,
  runtime: TelemetryRuntime,
  ctx: ProviderCreateContext,
): TelemetryProvider {
  return createProviderFromPlugin(config, runtime, ctx);
}
